import map from 'licia/map';
import isNum from 'licia/isNum';
import isStr from 'licia/isStr';
import { exportCjs, pxToNum } from '../share/util';
import Component from '../share/Component';
export default class BoxModel extends Component {
    constructor(container, options = {}) {
        super(container, { compName: 'box-model' });
        this.initOptions(options);
        if (this.options.element) {
            this.render();
        }
        this.bindEvent();
    }
    bindEvent() {
        this.on('optionChange', (name) => {
            switch (name) {
                case 'element':
                    this.render();
                    break;
            }
        });
    }
    render() {
        const { c } = this;
        const boxModel = this.getBoxModelData();
        this.$container.html([`<div class="${c('box-model')}">`,
            boxModel.position ? `<div class="${c('position')}">` : '',
            boxModel.position ? `<div class="${c('label')}">position</div><div class="${c('top')}">${boxModel.position.top}</div><br><div class="${c('left')}">${boxModel.position.left}</div>` : '',
            `<div class="${c('margin')}">`,
            `<div class="${c('label')}">margin</div><div class="${c('top')}">${boxModel.margin.top}</div><br><div class="${c('left')}">${boxModel.margin.left}</div>`,
            `<div class="${c('border')}">`,
            `<div class="${c('label')}">border</div><div class="${c('top')}">${boxModel.border.top}</div><br><div class="${c('left')}">${boxModel.border.left}</div>`,
            `<div class="${c('padding')}">`,
            `<div class="${c('label')}">padding</div><div class="${c('top')}">${boxModel.padding.top}</div><br><div class="${c('left')}">${boxModel.padding.left}</div>`,
            `<div class="${c('content')}">`,
            `<span>${boxModel.content.width}</span>&nbsp;×&nbsp;<span>${boxModel.content.height}</span>`,
            '</div>',
            `<div class="${c('right')}">${boxModel.padding.right}</div><br><div class="${c('bottom')}">${boxModel.padding.bottom}</div>`,
            '</div>',
            `<div class="${c('right')}">${boxModel.border.right}</div><br><div class="${c('bottom')}">${boxModel.border.bottom}</div>`,
            '</div>',
            `<div class="${c('right')}">${boxModel.margin.right}</div><br><div class="${c('bottom')}">${boxModel.margin.bottom}</div>`,
            '</div>',
            boxModel.position ? `<div class="${c('right')}">${boxModel.position.right}</div><br><div class="${c('bottom')}">${boxModel.position.bottom}</div>` : '',
            boxModel.position ? '</div>' : '',
            '</div>'].join(''));
    }
    getBoxModelData() {
        const { element } = this.options;
        const computedStyle = window.getComputedStyle(element);
        function getBoxModelValue(type) {
            let keys = ['top', 'left', 'right', 'bottom'];
            if (type !== 'position') {
                keys = map(keys, (key) => `${type}-${key}`);
            }
            if (type === 'border') {
                keys = map(keys, (key) => `${key}-width`);
            }
            return {
                top: boxModelValue(computedStyle[keys[0]], type),
                left: boxModelValue(computedStyle[keys[1]], type),
                right: boxModelValue(computedStyle[keys[2]], type),
                bottom: boxModelValue(computedStyle[keys[3]], type),
            };
        }
        const boxModel = {
            margin: getBoxModelValue('margin'),
            border: getBoxModelValue('border'),
            padding: getBoxModelValue('padding'),
            content: {
                width: boxModelValue(computedStyle['width']),
                height: boxModelValue(computedStyle['height']),
            },
        };
        if (computedStyle['position'] !== 'static') {
            boxModel.position = getBoxModelValue('position');
        }
        return boxModel;
    }
}
function boxModelValue(val, type) {
    if (isNum(val))
        return val;
    if (!isStr(val))
        return '‒';
    const ret = pxToNum(val);
    if (isNaN(ret))
        return val;
    if (type === 'position')
        return ret;
    return ret === 0 ? '‒' : ret;
}
if (typeof module !== 'undefined') {
    exportCjs(module, BoxModel);
}
